// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoTitle__wrapper___1Gzbf","is-reverse":"LogoTitle__is-reverse___7yUU5","name":"LogoTitle__name___2LTlu"};